import React, { useCallback, useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import FormElement from '@wix/da-ds/pkg/formControls/layouts/FormElement';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import InputErrorMessage from '@wix/da-ds/pkg/formControls/lego/InputErrorMessage';
import DescriptionEditor from '@wix/da-shared-react/pkg/DescriptionEditor';
import { CustomExclusiveFieldName } from '../../types';
import { UseEditorOptions } from '@wix/da-editor-tiptap/pkg/hooks/useEditor';

interface Props {}

const DescriptionField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control, errors, setValue, getValues } = useFormContext();
  const {
    field: { value },
  } = useController({ name: CustomExclusiveFieldName.DESCRIPTION, control });
  const error = errors[CustomExclusiveFieldName.DESCRIPTION];

  const handleChange: UseEditorOptions['onEditorChange'] = useCallback(
    editorState =>
      setValue(
        CustomExclusiveFieldName.DESCRIPTION,
        getValues(CustomExclusiveFieldName.DESCRIPTION),
        {
          shouldDirty: true,
        }
      ),
    [getValues, setValue]
  );

  return (
    <FormElement
      inputId={id}
      label={
        <InputLabelText isRequired>
          {t('customExclusivePopup.form.description.label')}
        </InputLabelText>
      }
      noBottomSpacing
    >
      <DescriptionEditor
        placeholder={t('customExclusivePopup.form.description.placeholder')}
        initialContent={value}
        onChange={handleChange}
      />
      {error && <InputErrorMessage>{error.message}</InputErrorMessage>}
    </FormElement>
  );
};
DescriptionField.displayName = 'DescriptionField';

export default DescriptionField;
